import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import {MdAttachFile, MdDeleteForever} from "react-icons/md";
import IconButton from "@material-ui/core/IconButton";
import {deleteBlobFile, findFilesByFileGcd} from "../../lib/api/file";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
    bizFileState,
    etcFileState, etcReturnFileState,
    intFileState,
    rentFileState,
    simpleFileState,
    userState
} from "../../state/globalState";
import Typography from "@material-ui/core/Typography";


const useStyles = makeStyles(theme => ({
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        border: "solid 1px #ededed",
        borderRadius: "10px",
        marginTop: "5px",
        backgroundColor: "#d9ecff",
    },
    fileItemWrapper: {
        display: "flex",
        alignItems: "center",
    }
}));

const DropzoneFileItem = (props) => {
    const userInfo = useRecoilValue(userState);
    const setIntFiles = useSetRecoilState(intFileState);
    const setBizFiles = useSetRecoilState(bizFileState);
    const setEtcFiles = useSetRecoilState(etcFileState);
    const setRentFiles = useSetRecoilState(rentFileState);
    const setSimpleFiles = useSetRecoilState(simpleFileState);
    const setEtcReturnFiles = useSetRecoilState(etcReturnFileState);
    const { fileUuid, bizFileSeq, fileSeq, fileNm, kognrFileGcd } = props;
    const classes = useStyles();

    const getFiles = async (admnNo, stdYear) => {
        const { data } = await findFilesByFileGcd(admnNo, stdYear);
        if (data.success) {
            const files = data.payload.filter((file) => (file.kognrFileGcd === kognrFileGcd))
            if (kognrFileGcd === "HC050001") {
                setIntFiles(files);
            } else if (kognrFileGcd === "HC050002") {
                setBizFiles(files);
            } else if (kognrFileGcd === "HC050003") {
                setEtcFiles(files);
            } else if (kognrFileGcd === "HC050004") {
                setRentFiles(files);
            } else if (kognrFileGcd === "HC050005") {
                setSimpleFiles(files);
            } else if (kognrFileGcd === "HC050006") {
                setEtcReturnFiles(files);
            }
        }
    }

    const deleteFile = () => {
        deleteBlobFile(fileUuid, bizFileSeq, fileSeq).then((res) => {
            const { data } = res;
            if (data.success) {
                getFiles(userInfo.admnNo, userInfo.stdYear);
            }
        });
    }

    return (
        <div className={classes.container}>
            <div className={classes.fileItemWrapper}>
                <MdAttachFile size={24} />
                <Typography variant="body1" color="textPrimary">
                    {fileNm}
                </Typography>
            </div>
            <IconButton aria-label="file-delete" onClick={deleteFile}>
                <MdDeleteForever size={24} color="#f74200" />
            </IconButton>
        </div>
    )
};

export default DropzoneFileItem;
